import { inject, injectable } from 'inversify';
import type { IAdapter } from '@dealroadshow/json-rpc-dispatcher';
import { IDispatcherFactory } from './DI/interfaces';
import JsonRpcDispatcher, { interceptors } from '@dealroadshow/json-rpc-dispatcher';
import addSessionData from '@users/session/interceptors/rpc/addSessionData';
import checkSession from '@users/session/interceptors/rpc/checkSession';
import parseWrappedError from '@framework/api/Rpc/parseWrappedError';
import Container from '@framework/di/Container';

@injectable()
export class DispatcherFactory implements IDispatcherFactory {
  constructor(@inject(Container) private readonly container: Container) {}

  create(adapter: IAdapter) {
    return new JsonRpcDispatcher(adapter)
      .interceptRequest(addSessionData(this.container))
      .interceptResponse(checkSession(this.container))
      .interceptResponse(parseWrappedError())
      .interceptResponse(interceptors.response.transformErrorToException);
  }
}
